module.exports = __webpack_public_path__ + "img/pexels-chevanon-photography-1108101 1.c6ad92be.png";